module.exports = __webpack_public_path__ + "img/menuIcon1.0f5b90ba.png";